/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Link } from './link';
import { Optional } from './optional';
import { TechnicalData } from './technicalData';

export interface VehicleDetail {
  plateNumber?: string;
  purchaseYearCode?: string;
  purchaseYearDesc?: string;
  vehicleType?: VehicleDetail.VehicleTypeEnum;
  specialVehicleCode?: VehicleDetail.SpecialVehicleCodeEnum;
  specialVehicleDesc?: string;
  vehicleProvinceCode?: string;
  vehicleProvinceDesc?: string;
  numberOfCitizens?: string;
  selectedDeductibleCode?: VehicleDetail.SelectedDeductibleCodeEnum;
  selectedDeductibleDesc?: VehicleDetail.SelectedDeductibleDescEnum;
  selectedLimitCode?: VehicleDetail.SelectedLimitCodeEnum;
  selectedLimitDesc?: VehicleDetail.SelectedLimitDescEnum;
  ownBehalfCode?: VehicleDetail.OwnBehalfCodeEnum;
  ownBehalfDesc?: VehicleDetail.OwnBehalfDescEnum;
  numberOfSeats?: string;
  vehicleSubTypeCode?: string;
  vehicleSubTypeDesc?: string;
  inforCarCode?: string;
  infoCarDate?: Date;
  vehicleMileageCode?: string;
  vehicleMileageDesc?: string;
  nightRecoveryCode?: string;
  nightRecoveryDesc?: string;
  kw?: string;
  fuelTypeCode?: string;
  fuelTypeDesc?: string;
  antitheftCode?: string;
  antitheftDesc?: string;
  matriculationMonthCode?: string;
  matriculationMonthDesc?: string;
  matriculationYearCode?: string;
  matriculationYearDesc?: string;
  habitualUseCode?: string;
  habitualUseDesc?: string;
  makerCode?: string;
  makerDesc?: string;
  modelCode?: string;
  modelDesc?: string;
  ccCapacity?: string;
  versionCode?: string;
  versionDesc?: string;
  vechicleAlreadyInsured?: boolean;
  leasedVehicleValue?: number;
  leasedVehicleTotalValue?: number;
  actualValue?: number;
  progrSetUp?: string;
  immatricolazioneNoleggio?: boolean;
  vehicleTowing?: boolean;
  usageVehicleCode?: string;
  usageVehicleDesc?: string;
  typeUsageVehicleCode?: string;
  typeUsageVehicleDesc?: string;
  fullLoadMass?: number;
  loadCapacityA?: number;
  loadCapacityFrom?: number;
  volumeCargo?: number;
  denominationType?: number;
  link?: Link;
  technicalData?: TechnicalData;
  optionals?: Array<Optional>;
}
export namespace VehicleDetail {
  export type VehicleTypeEnum = 'AUTO' | 'MOTOCICLO' | 'VAN';
  export const VehicleTypeEnum = {
    AUTO: 'AUTO' as VehicleTypeEnum,
    MOTOCICLO: 'MOTOCICLO' as VehicleTypeEnum,
    VAN: 'VAN' as VehicleTypeEnum,
  };
  export type SpecialVehicleCodeEnum =
    | 'AUTOBUS_PUBBLICO_URBANO'
    | 'AUTOBUS_TURISMO_NON_URBANO'
    | 'TAXI'
    | 'CICLI_MOTOCICLI_TRASPORTO_COSE'
    | 'AUTOCARRI_OLTRE_35_QUINTALI'
    | 'MACCHINE_AGRICOLE'
    | 'VEICOLI_SPECIALI'
    | 'RIMORCHIO_AUTOVETTURE'
    | 'RIMORCHIO_AUTOBUS'
    | 'RIMORCHIO_AUTOCARRI'
    | 'RIMORCHIO_MACCHINE_AGRICOLE'
    | 'RIMORCHIO_VEICOLI_SPECIALI'
    | 'CAMPER';
  export const SpecialVehicleCodeEnum = {
    AUTOBUSPUBBLICOURBANO: 'AUTOBUS_PUBBLICO_URBANO' as SpecialVehicleCodeEnum,
    AUTOBUSTURISMONONURBANO: 'AUTOBUS_TURISMO_NON_URBANO' as SpecialVehicleCodeEnum,
    TAXI: 'TAXI' as SpecialVehicleCodeEnum,
    CICLIMOTOCICLITRASPORTOCOSE: 'CICLI_MOTOCICLI_TRASPORTO_COSE' as SpecialVehicleCodeEnum,
    AUTOCARRIOLTRE35QUINTALI: 'AUTOCARRI_OLTRE_35_QUINTALI' as SpecialVehicleCodeEnum,
    MACCHINEAGRICOLE: 'MACCHINE_AGRICOLE' as SpecialVehicleCodeEnum,
    VEICOLISPECIALI: 'VEICOLI_SPECIALI' as SpecialVehicleCodeEnum,
    RIMORCHIOAUTOVETTURE: 'RIMORCHIO_AUTOVETTURE' as SpecialVehicleCodeEnum,
    RIMORCHIOAUTOBUS: 'RIMORCHIO_AUTOBUS' as SpecialVehicleCodeEnum,
    RIMORCHIOAUTOCARRI: 'RIMORCHIO_AUTOCARRI' as SpecialVehicleCodeEnum,
    RIMORCHIOMACCHINEAGRICOLE: 'RIMORCHIO_MACCHINE_AGRICOLE' as SpecialVehicleCodeEnum,
    RIMORCHIOVEICOLISPECIALI: 'RIMORCHIO_VEICOLI_SPECIALI' as SpecialVehicleCodeEnum,
    CAMPER: 'CAMPER' as SpecialVehicleCodeEnum,
  };
  export type SelectedDeductibleCodeEnum = 'FIRST' | 'SECOND' | 'THIRD';
  export const SelectedDeductibleCodeEnum = {
    FIRST: 'FIRST' as SelectedDeductibleCodeEnum,
    SECOND: 'SECOND' as SelectedDeductibleCodeEnum,
    THIRD: 'THIRD' as SelectedDeductibleCodeEnum,
  };
  export type SelectedDeductibleDescEnum = 'FIRST' | 'SECOND' | 'THIRD';
  export const SelectedDeductibleDescEnum = {
    FIRST: 'FIRST' as SelectedDeductibleDescEnum,
    SECOND: 'SECOND' as SelectedDeductibleDescEnum,
    THIRD: 'THIRD' as SelectedDeductibleDescEnum,
  };
  export type SelectedLimitCodeEnum = 'FIRST' | 'SECON';
  export const SelectedLimitCodeEnum = {
    FIRST: 'FIRST' as SelectedLimitCodeEnum,
    SECON: 'SECON' as SelectedLimitCodeEnum,
  };
  export type SelectedLimitDescEnum = 'FIRST' | 'SECOND';
  export const SelectedLimitDescEnum = {
    FIRST: 'FIRST' as SelectedLimitDescEnum,
    SECOND: 'SECOND' as SelectedLimitDescEnum,
  };
  export type OwnBehalfCodeEnum = 'CONTO_PROPRIO' | 'CONTO_TERZI';
  export const OwnBehalfCodeEnum = {
    PROPRIO: 'CONTO_PROPRIO' as OwnBehalfCodeEnum,
    TERZI: 'CONTO_TERZI' as OwnBehalfCodeEnum,
  };
  export type OwnBehalfDescEnum = 'CONTO_PROPRIO' | 'CONTO_TERZI';
  export const OwnBehalfDescEnum = {
    PROPRIO: 'CONTO_PROPRIO' as OwnBehalfDescEnum,
    TERZI: 'CONTO_TERZI' as OwnBehalfDescEnum,
  };
}
